import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class FallingRiskMorseScale {
    exportExcel(data, fecha_inicial, fecha_final) {
        let option = {};  // La opción representa el archivo de Excel
        console.log(data);
        let fallingRiskPatients = this.fallingRiskPatients(data, fecha_inicial, fecha_final);
        option.fileName = 'Reporte de Riesgo de Caida';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: fallingRiskPatients.data,  // Fuente de datos en archivo Excel
                sheetName: 'Riesgo de Caida',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
        
    }

    fallingRiskPatients(fallingRiskStadistic, fecha_inicial, fecha_final) {
        let data_patient = fallingRiskStadistic.pacientes;
        let dataTable = [];  // Contenido de datos en archivo Excel
        let Casillas = this.generarCasillas();//Casillas Vacias y Preconfiguradas
        
        dataTable.push(Casillas);
        
        let tituloNombreEmpresa = this.generarTituloPerfil();//Titulo Nombre de Empresa
        let titulosCierreCaja = this.generarTituloConVacios();//Titulos del Recibo de Caja
        let tituloFechaInicial = this.generarTituloFechaInicial(fecha_inicial);
        let tituloFechaFinal = this.generarTituloFechaFinal(fecha_final);
        
        dataTable.push(tituloNombreEmpresa);
        dataTable.push(titulosCierreCaja);
        dataTable.push(tituloFechaInicial);
        dataTable.push(tituloFechaFinal);
        dataTable.push(Casillas);

        //Generacion de Recibos de Caja en el Excel
        if (data_patient.length > 0) {
            let Titulos = this.generarTituloPaciente();//Titulos del Recibo de Caja
            dataTable.push(Titulos);

            for (let i in data_patient) {  // Ciclo de obtener los datos de cada fila en Excel
                let obj = this.generarDatosPaciente(data_patient[i]);
                dataTable.push(obj);  // Establecer la fuente de datos obtenida por cada columna en Excel
            }

            dataTable.push(Casillas);

            //Esteban Londoño Ospina 12/11/2021
            //Muestra las estadisticas del Riesgo de Caida y el total
            let totalCasilla = this.generarCasillaTotal(fallingRiskStadistic.total_pacientes);
            let riesgoBajo = this.generarCasillaPorcentajeRiesgoBajo(fallingRiskStadistic.riesgo_bajo);
            let riesgoMedio = this.generarCasillaPorcentajeRiesgoMedio(fallingRiskStadistic.riesgo_medio);
            let riesgoAlto = this.generarCasillaPorcentajeRiesgoAlto(fallingRiskStadistic.riesgo_alto);

            dataTable.push(totalCasilla);
            dataTable.push(riesgoBajo);
            dataTable.push(riesgoMedio);
            dataTable.push(riesgoAlto);
        }

        let sheet =
        {
            data: dataTable
        }
        return sheet;
    }

    generarCasillas() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': "",
        }
        return casillas;
    }

    generarTituloPerfil() {
        let perfil = sessionStorage.getItem('perfil');
        let Titulos = {
            '1': 'Nombre de Empresa',
            '2': sessionStorage.getItem('nombre_empresa'),
        }
        return Titulos;
    }

    generarTituloConVacios() {
        let Titulos = {
            '1': 'Tipo de Reporte',
            '2': "Reporte de Riesgo de Caida",
        }
        return Titulos;
    }

    generarTituloFechaInicial(fecha_inicial) {
        let Titulos = {
            '1': 'Fecha Inicial',
            '2': moment(fecha_inicial).format('DD/MM/YYYY'),
        }
        return Titulos;
    }

    generarTituloFechaFinal(fecha_final) {
        let Titulos = {
            '1': 'Fecha Final',
            '2': moment(fecha_final).format('DD/MM/YYYY'),
        }
        return Titulos;
    }

    generarTituloPaciente() {
        let Titulos = {
            '1': "Admisión",
            '2': "Fecha Admisión",
            '3': "Paciente",
            '4': "Calificación"
        }
        return Titulos;
    }

    generarDatosPaciente(paciente) {
        let recibo = {
            '1': paciente.id_admision,
            '2': moment(new Date(paciente.fecha)).format('DD/MM/YYYY'),
            '3': paciente.nombre_paciente,
            '4': paciente.riesgo
        }
        return recibo;
    }

    generarCasillaTotal(total_pacientes)
    {
        let CasillasEstadisticas = {
            '1': 'Total de Pacientes',
            '2': total_pacientes.toString(),
        }
        return CasillasEstadisticas;
    }

    generarCasillaPorcentajeRiesgoBajo(riesgo)
    {
        let CasillasEstadisticas = {
            '1': 'Riesgo Bajo',
            '2': riesgo.toString(),
        }
        return CasillasEstadisticas;
    }

    generarCasillaPorcentajeRiesgoMedio(riesgo)
    {
        let CasillasEstadisticas = {
            '1': 'Riesgo Medio',
            '2': riesgo.toString(),
        }
        return CasillasEstadisticas;
    }

    generarCasillaPorcentajeRiesgoAlto(riesgo)
    {
        let CasillasEstadisticas = {
            '1': 'Riesgo Alto',
            '2': riesgo.toString(),
        }
        return CasillasEstadisticas;
    }

}

export default new FallingRiskMorseScale();